export enum UrlParams {
	PageIndex = 'pi',
	SearchOnlyUnacknowledge = 'sou',
}

export default UrlParams;
